module.exports = __webpack_public_path__ + "img/Group 2027493.aef55207.png";